<template>
  <div>
    <common-dialog
      ref="dialog"
      width="995px"
      unit="补货申请"
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
     
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
     
     
      form-label-width="85px"
    
      @closed="$emit('closed')"
    >
      <template slot="form">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="商品名称" prop="GoodsName">
               {{ data.GoodsName }}
              </el-form-item>
            </el-col>
             <!-- <el-col :span="isMB ? 24 : 12">
            
               <el-form-item label="规格型号" prop="AttributeName">
                   {{ data.AttributeName }}
               </el-form-item>
            </el-col>  -->
                     
           </el-row>
                                          
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="联系号码" prop="ContactPhone">
                 {{ data.ContactPhone}}
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="用户姓名" prop="PersonName">
               {{ data.PersonName}}
              </el-form-item>
            </el-col>
            
          </el-row>

          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="申请时间" prop="ApplyTime">
                  {{ $commonJs.toDatetimeString(data.ApplyTime) }}
              </el-form-item>
            </el-col>
                    
          </el-row>


        </template>
        <template #footer >
           <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";


export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
        data: {
          RecordId: 0,
         
         GoodsName: "",
        //  AttributeName: "",
         ContactPhone: "",
         PersonName: "",
         ApplyTime: "",
          State: 1,
          },
       
        api: require("@/api/sale/apply").default,
      isMB: this.$store.state.isMB,
     
    };
  },
  methods: {
    onCreateOpened(data) {
    },
    onDetailsOpened(data) {
     this.api.updatestate(data.RecordId).then(res => {
        if (res.Code == 0) {
       //   this.$message.success(res.Msg);
        //  this.reload();
        } else {
      //    this.$message.error(res.Msg);
        }
      })
    }, 
    onClosed() {
    },      
  }
};
</script>
<style lang="scss">
.file-text2{
  .el-upload--text {
    display: none;
  }
  .el-upload-list__item-name {
    margin-top: -8px;
  }
}
</style>